// assets/pw-zones.js
// Single source of truth for Philip Warren PL/TR local-delivery coverage.
// Loaded as a plain <script> via {{ 'pw-zones.js' | asset_url | script_tag }} — NO ES modules.
//
// ⚠️ PHASE 1 COUPLING (front-end depends on Shopify settings you configure in admin):
//    This list MUST stay identical to the Shopify Local Delivery zone at
//    Settings → Shipping and delivery → Local delivery (Launceston + Rock).
//    They CANNOT be auto-synced. If van coverage ever changes, edit BOTH this file
//    AND the Shopify zone, at the SAME granularity — otherwise you create a
//    "gate says yes → checkout says no" trap. Add this to the ops runbook.
//
// matchMode:
//   "area"     → match leading letters only (PL*, TR*). Use if the vans cover ALL of PL and TR.
//   "district" → match the full outward code (PL1, PL2, TR1, …). Use if coverage is partial;
//                then enumerate every served district in 'prefixes'.
//
// NOTE: PL covers Plymouth and parts of Devon, not just Cornwall — confirm that's in van range.
window.PW_ZONES = {
  prefixes: ["PL", "TR"],
  matchMode: "area"
};
